(function () {
  if (window.__cleverpupBundleModulesLoaded) {
    return;
  }
  window.__cleverpupBundleModulesLoaded = true;

  let isBundleSubmitting = false;
  let allowMainAddToCartOnce = false;
  let listenersBound = false;

  function normalize(s) {
    return (s || '').toString().trim();
  }

  function lower(s) {
    return normalize(s).toLowerCase();
  }

  function getBundleContainers() {
    return Array.from(
      document.querySelectorAll('.more-products.bundle-it-products, .bundle-it-products, .two-bundle-products'),
    );
  }

  function findBundleContainer() {
    return getBundleContainers()[0] || null;
  }

  function getSyncMainContainer() {
    return (
      getBundleContainers().find(
        (container) =>
          container.getAttribute('data-bundle-mode') === 'sync-main' || container.hasAttribute('data-bundle-shell'),
      ) || null
    );
  }

  function getBundleSelects(container) {
    if (!container) return [];
    return Array.from(container.querySelectorAll('select.product-options[data-bundleit-select]'));
  }

  function getMainSelectedSize() {
    const checkedRadio =
      document.querySelector('input[type="radio"][name^="options["][name*="Size"]:checked') ||
      document.querySelector('input[type="radio"][name^="options["][name*="size"]:checked') ||
      document.querySelector('input[type="radio"][name^="options["][name*="Tama"]:checked') ||
      document.querySelector('input[type="radio"][name*="Size"]:checked') ||
      document.querySelector('input[type="radio"][name*="size"]:checked') ||
      document.querySelector('input[type="radio"][name*="Tama"]:checked');

    if (checkedRadio) return normalize(checkedRadio.value);

    const sizeSelect =
      document.querySelector('select[name^="options["][name*="Size"]') ||
      document.querySelector('select[name^="options["][name*="size"]') ||
      document.querySelector('select[name^="options["][name*="Tama"]');

    if (sizeSelect) return normalize(sizeSelect.value);

    const sizeInfo = Array.from(document.querySelectorAll('.variant__label-info span'))
      .map((el) => normalize(el.textContent))
      .find((t) => ['small', 'medium', 'large'].includes(lower(t)));

    if (sizeInfo) return sizeInfo;

    const container = getSyncMainContainer() || findBundleContainer();
    if (container) {
      return normalize(container.getAttribute('data-shell-size'));
    }

    return '';
  }

  function getMainSelectedColor() {
    const checkedRadio =
      document.querySelector('input[type="radio"][name^="options["][name*="Color"]:checked') ||
      document.querySelector('input[type="radio"][name^="options["][name*="color"]:checked') ||
      document.querySelector('input[type="radio"][name^="options["][name*="Colour"]:checked') ||
      document.querySelector('input[type="radio"][name*="Color"]:checked') ||
      document.querySelector('input[type="radio"][name*="color"]:checked') ||
      document.querySelector('input[type="radio"][name*="Colour"]:checked');

    if (checkedRadio) return normalize(checkedRadio.value);

    const colorSelect =
      document.querySelector('select[name^="options["][name*="Color"]') ||
      document.querySelector('select[name^="options["][name*="color"]') ||
      document.querySelector('select[name^="options["][name*="Colour"]');

    if (colorSelect) return normalize(colorSelect.value);

    const colorInfo = Array.from(document.querySelectorAll('.variant__label-info span'))
      .map((el) => normalize(el.textContent))
      .find((t) => t && !['small', 'medium', 'large'].includes(lower(t)));

    if (colorInfo) return colorInfo;

    return '';
  }

  function updateCardFromSelect(selectEl) {
    const card = selectEl.closest('.product-item, [data-bundleit-card], .bundle-it-products__card');
    if (!card) return;

    const opt = selectEl.options[selectEl.selectedIndex];
    if (!opt) return;

    card.dataset.selectedVariantId = selectEl.value;

    const variantUrl = opt.getAttribute('data-url');
    if (variantUrl) {
      const links = card.querySelectorAll('a[href]');
      links.forEach((link) => {
        link.href = variantUrl;
      });
    }

    const imgUrl = opt.getAttribute('data-img') || opt.getAttribute('data-image');
    if (imgUrl) {
      const img = card.querySelector('img.product-image, .image_with_frequently-paired img, img');
      if (img) {
        img.removeAttribute('srcset');
        img.removeAttribute('data-srcset');
        img.src = imgUrl;
      }
    }

    updateTwoBundlePrice();
  }

  function formatBundlePrice(cents) {
    if (window.theme && window.theme.Currency && window.theme.settings && window.theme.settings.moneyFormat) {
      return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
    }
    const dollars = cents / 100;
    const str = dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2);
    return '$' + str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function updateTwoBundlePrice() {
    const twoBundleContainer = document.querySelector('.two-bundle-products');
    if (!twoBundleContainer) return;

    const shellPriceCents = parseInt(twoBundleContainer.dataset.shellPriceRaw || '0', 10);
    if (!shellPriceCents) return;

    const shellCompareAtCents = parseInt(twoBundleContainer.dataset.shellCompareAtRaw || '0', 10);
    const formatted = formatBundlePrice(shellPriceCents);

    document.querySelectorAll('[data-product-price]').forEach((el) => {
      el.textContent = formatted;
      el.classList.toggle('on-sale', shellCompareAtCents > shellPriceCents);
    });

    document.querySelectorAll('[data-product-price-wrap]').forEach((el) => {
      el.classList.toggle('hide', !(shellCompareAtCents > shellPriceCents));
    });

    document.querySelectorAll('[data-compare-price]').forEach((el) => {
      el.textContent = shellCompareAtCents > shellPriceCents ? formatBundlePrice(shellCompareAtCents) : '';
    });

    const atcSpan = document.querySelector('[data-add-to-cart-text]');
    if (atcSpan) {
      if (window.theme && window.theme.strings && window.theme.strings.addtocartprice) {
        atcSpan.textContent = window.theme.strings.addtocartprice.replace('[price]', formatted);
      } else {
        atcSpan.textContent = (atcSpan.dataset.defaultText || 'Add to Cart') + ' - ' + formatted;
      }
    }
  }

  function normalizeBundleSize(value) {
    const raw = lower(value).trim();
    if (!raw) return '';

    const shortcuts = {
      small: ['small', 's', 'sm', 'xs', 'xsmall', 'pequeño', 'pequenio', 'pequeña', 'chico', 'chica'],
      medium: ['medium', 'm', 'md', 'med', 'mediano', 'medio'],
      large: ['large', 'l', 'lg', 'xl', 'xlarge', 'grande'],
    };

    for (const key in shortcuts) {
      if (shortcuts[key].includes(raw)) return key;
    }

    if (raw.includes('small')) return 'small';
    if (raw.includes('medium')) return 'medium';
    if (raw.includes('large')) return 'large';

    return raw;
  }

  function normalizeShellState(value) {
    const raw = lower(value);
    if (!raw) return '';
    if (raw.includes('both') || raw.includes('combo')) return 'both';
    return normalizeBundleSize(raw);
  }

  function initShellVariantMappings(container) {
    if (!container) return;

    const scriptEl = container.querySelector('script[data-two-bundle-variants]');
    if (!scriptEl) return;

    try {
      const data = JSON.parse(scriptEl.textContent);
      if (!data.variants || !Array.isArray(data.variants)) return;

      container._twoBundleShellVariants = {};
      container._twoBundleShellStateById = {};

      data.variants.forEach((v) => {
        const state = normalizeShellState(v.title);
        if (state) {
          container._twoBundleShellVariants[state] = String(v.id);
          container._twoBundleShellStateById[String(v.id)] = state;
        }
      });
    } catch (e) {
      console.warn('bundle-it: failed to parse shell variants', e);
    }
  }

  function getShellVariantIdForSizes(container, size1, size2) {
    if (!container || !container._twoBundleShellVariants) return null;

    const normalized1 = normalizeBundleSize(size1);
    const normalized2 = normalizeBundleSize(size2);
    if (!normalized1 || !normalized2) return null;

    if (normalized1 === normalized2) {
      return container._twoBundleShellVariants[normalized1] || null;
    }

    // For "both" we allow one small and one non-small size (medium, large, etc.)
    const hasSmallAndOther =
      (normalized1 === 'small' && normalized2 !== 'small') || (normalized2 === 'small' && normalized1 !== 'small');

    if (hasSmallAndOther) return container._twoBundleShellVariants.both || null;

    return null;
  }

  function getSelectedSizesFromBundleSelects(container) {
    const selects = getBundleSelects(container);
    if (selects.length < 2) return { size1: '', size2: '' };

    const opt1 = selects[0].options[selects[0].selectedIndex];
    const opt2 = selects[1].options[selects[1].selectedIndex];

    return {
      size1: opt1 ? opt1.getAttribute('data-size') || '' : '',
      size2: opt2 ? opt2.getAttribute('data-size') || '' : '',
    };
  }

  function updateShellVariantFromBundleSelects(container) {
    if (!container) return;
    const { size1, size2 } = getSelectedSizesFromBundleSelects(container);
    const shellVariantId = getShellVariantIdForSizes(container, size1, size2);

    if (!shellVariantId) {
      console.warn('bundle-it: no shell variant found for combo', size1, size2);
      return;
    }

    const shellSelect = document.querySelector('select[name="id"][data-product-select], select[data-product-select]');
    if (shellSelect && shellSelect.value !== shellVariantId) {
      shellSelect.value = shellVariantId;
      shellSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function filterTwoBundleSelect(selectEl, targetSize) {
    // Cache original options the first time
    if (!selectEl._bundleitOriginalOptions) {
      selectEl._bundleitOriginalOptions = Array.from(selectEl.options).map((opt) => opt.cloneNode(true));
    }

    const originals = selectEl._bundleitOriginalOptions;
    const matching = originals.filter((opt) => normalizeBundleSize(opt.getAttribute('data-size') || '') === targetSize);
    const candidates = matching.length ? matching : originals.slice();

    // Rebuild select with only the allowed options
    selectEl.innerHTML = '';
    candidates.forEach((opt) => {
      const cloned = opt.cloneNode(true);
      cloned.removeAttribute('hidden');
      selectEl.appendChild(cloned);
    });

    // Auto-select first available
    const firstEnabled = Array.from(selectEl.options).find((o) => !o.disabled);
    if (firstEnabled) selectEl.value = firstEnabled.value;
  }

  function updateBundleSelectsFromShellVariant(container, shellVariantId) {
    if (!container || !shellVariantId) return;

    const shellState = container._twoBundleShellStateById && container._twoBundleShellStateById[String(shellVariantId)];
    if (!shellState) return;

    let targetSizes;
    if (shellState === 'small') targetSizes = ['small', 'small'];
    else if (shellState === 'both') {
      const availableSizes = Array.from(
        new Set(
          getBundleSelects(container).flatMap((sel) => {
            return getOriginalBundleOptions(sel)
              .map((opt) => normalizeBundleSize(opt.getAttribute('data-size') || ''))
              .filter(Boolean)
              .filter((size) => size !== 'both');
          }),
        ),
      );

      const nonSmallTarget = availableSizes.find((size) => size !== 'small') || 'medium';
      targetSizes = ['small', nonSmallTarget];
    } else {
      // For single shell states (medium, large, etc.), force both selects to that size
      targetSizes = [shellState, shellState];
    }

    const selects = getBundleSelects(container);
    if (selects.length < 2) return;

    selects.forEach((sel, idx) => {
      const targetSize = targetSizes[idx] || targetSizes[0];
      filterTwoBundleSelect(sel, targetSize);
      updateCardFromSelect(sel);
    });

    updateTwoBundlePrice();
  }

  function getOriginalBundleOptions(selectEl) {
    if (!selectEl) return [];
    if (!selectEl._bundleitOriginalOptions) {
      selectEl._bundleitOriginalOptions = Array.from(selectEl.options).map((opt) => opt.cloneNode(true));
    }
    return selectEl._bundleitOriginalOptions;
  }

  function buildFilteredOptions(selectEl, size) {
    const originals = getOriginalBundleOptions(selectEl);
    const requestedSize = normalizeBundleSize(size);

    let candidates = originals.filter((opt) => {
      const optSize = normalizeBundleSize(opt.getAttribute('data-size') || '');
      if (!requestedSize) return true;
      if (optSize === requestedSize) return true;
      if (!optSize) return true;
      return optSize.includes(requestedSize) || requestedSize.includes(optSize);
    });

    if (!candidates.length) {
      const availableSmall = originals.filter(
        (opt) => normalizeBundleSize(opt.getAttribute('data-size') || '') === 'small',
      );
      if (availableSmall.length) {
        candidates = availableSmall;
      } else {
        candidates = originals.slice();
      }
    }

    return candidates;
  }

  function applyFilteredOptions(selectEl, size, color) {
    if (!selectEl) return;

    const preservedValue = selectEl.value;
    const filtered = buildFilteredOptions(selectEl, size);

    const findColorMatch = (opts, targetColor) => {
      if (!targetColor) return null;
      const wanted = lower(targetColor);
      return opts.find((opt) => {
        const text = lower(opt.textContent || opt.text || '');
        const optColor = lower(opt.getAttribute('data-color') || '');
        return text.includes(wanted) || optColor.includes(wanted);
      });
    };

    const colorMatch = findColorMatch(filtered, color);
    const sizeDefaultMatch = filtered.find((opt) => {
      const flag = lower(opt.getAttribute('data-select-default') || '');
      return flag === 'true' && !opt.disabled;
    });

    let targetValue = '';
    if (colorMatch) targetValue = colorMatch.value;
    else if (sizeDefaultMatch) targetValue = sizeDefaultMatch.value;
    else if (preservedValue && filtered.some((opt) => opt.value === preservedValue)) targetValue = preservedValue;
    else if (filtered.length) targetValue = filtered[0].value;

    selectEl.innerHTML = '';
    filtered.forEach((opt) => {
      const cloned = opt.cloneNode(true);
      cloned.removeAttribute('hidden');
      selectEl.appendChild(cloned);
    });

    if (targetValue) selectEl.value = targetValue;
    if (!selectEl.value && filtered.length) selectEl.value = filtered[0].value;
  }

  function syncBundleSelect(selectEl, size, color) {
    applyFilteredOptions(selectEl, size, color);
    updateCardFromSelect(selectEl);
    selectEl.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function applySizeAndColorToAllBundleSelects() {
    const size = getMainSelectedSize();
    const color = getMainSelectedColor();

    getBundleContainers().forEach((container) => {
      const isSyncMain =
        container.getAttribute('data-bundle-mode') === 'sync-main' || container.hasAttribute('data-bundle-shell');
      if (!isSyncMain) return;

      if (size) {
        container.setAttribute('data-shell-size', size);
      }

      getBundleSelects(container).forEach((selectEl) => syncBundleSelect(selectEl, size, color));
    });
  }

  function collectBundleItems() {
    const items = [];

    getBundleContainers().forEach((container) => {
      getBundleSelects(container).forEach((selectEl) => {
        const current = selectEl.options[selectEl.selectedIndex];

        if (!current || current.disabled) {
          const fallback = Array.from(selectEl.options).find((opt) => !opt.disabled);
          if (fallback) {
            selectEl.value = fallback.value;
            selectEl.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        const variantId = selectEl.value;
        if (!variantId) return;

        const existing = items.find((item) => item.id === variantId);
        if (existing) {
          existing.quantity += 1;
        } else {
          items.push({ id: variantId, quantity: 1 });
        }
      });
    });

    return items;
  }

  function disableButton(btn, disabled) {
    if (!btn) return;

    if (disabled) {
      btn.setAttribute('disabled', 'disabled');
      btn.classList.add('is-loading');
    } else {
      btn.removeAttribute('disabled');
      btn.classList.remove('is-loading');
    }
  }

  async function addBundleItemsThenContinue(mainButton) {
    const items = collectBundleItems();

    if (!items.length) {
      allowMainAddToCartOnce = true;
      mainButton.click();
      return;
    }

    isBundleSubmitting = true;
    disableButton(mainButton, true);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) {
        throw new Error('Bundle add failed');
      }

      await response.json();

      if (window.theme && typeof window.theme.CartDrawer === 'function') {
        try {
          const cart = new theme.CartDrawer();
          cart.init();
          cart.open();
        } catch (e) {
          console.warn('bundle-it: unable to open cart drawer', e);
        }
      } else {
        window.location.href = '/cart';
      }
    } catch (error) {
      console.error('Bundle It add-to-cart error:', error);
      alert('No pudimos agregar los productos del bundle. Probá de nuevo.');
    } finally {
      isBundleSubmitting = false;
      disableButton(mainButton, false);
    }
  }

  function onBundleSelectChange() {
    document.addEventListener('change', function (e) {
      const t = e.target;
      if (t && t.matches && t.matches('select.product-options[data-bundleit-select]')) {
        updateCardFromSelect(t);

        // If two-bundle, sync to shell variant
        const container = t.closest('.two-bundle-products');
        if (container) {
          setTimeout(() => updateShellVariantFromBundleSelects(container), 0);
        }
      }
    });
  }

  function onMainVariantChange() {
    document.addEventListener('change', function (e) {
      const t = e.target;
      if (!t) return;

      const isOptionControl =
        (t.matches && t.matches('select[name^="options["]')) ||
        (t.matches && t.matches('input[type="radio"][name^="options["]')) ||
        (t.matches && t.matches('input[type="radio"]'));

      if (isOptionControl) {
        setTimeout(applySizeAndColorToAllBundleSelects, 0);
      }
    });

    document.addEventListener('click', function (e) {
      const t = e.target;
      if (!t) return;

      const inVariantUI = t.closest && t.closest('.variant-wrapper, .variant-input-wrap, .product-form__input');
      if (inVariantUI) {
        setTimeout(applySizeAndColorToAllBundleSelects, 0);
        setTimeout(applySizeAndColorToAllBundleSelects, 80);
      }
    });

    document.addEventListener('variant:change', function (evt) {
      const variant = evt.detail && evt.detail.variant;
      if (variant) {
        const twoBundleContainer = document.querySelector('.two-bundle-products');
        if (twoBundleContainer) {
          twoBundleContainer.dataset.shellPriceRaw = variant.price;
          twoBundleContainer.dataset.shellCompareAtRaw = variant.compare_at_price || 0;

          // Sync shell variant to bundle selects if this is a two-bundle product
          if (variant.id) {
            updateBundleSelectsFromShellVariant(twoBundleContainer, variant.id);
          }
        }
      }
      applySizeAndColorToAllBundleSelects();
      setTimeout(updateTwoBundlePrice, 120);
    });
    document.addEventListener('product:variant-change', applySizeAndColorToAllBundleSelects);
  }

  function onMainAddToCartIntercept() {
    document.addEventListener(
      'click',
      function (e) {
        const btn = e.target.closest('.add-to-cart, [data-add-to-cart]');
        if (!btn) return;

        if (!getBundleContainers().length) return;

        if (allowMainAddToCartOnce) {
          allowMainAddToCartOnce = false;
          return;
        }

        if (isBundleSubmitting) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return;
        }

        e.preventDefault();
        e.stopImmediatePropagation();

        addBundleItemsThenContinue(btn);
      },
      true,
    );
  }

  function bindListeners() {
    if (listenersBound) return;
    listenersBound = true;

    onBundleSelectChange();
    onMainVariantChange();
    onMainAddToCartIntercept();
  }

  function initBundleIt() {
    if (!getBundleContainers().length) return;

    const twoBundleContainer = document.querySelector('.two-bundle-products');
    if (twoBundleContainer) {
      initShellVariantMappings(twoBundleContainer);
    }

    bindListeners();

    const runSync = () => {
      applySizeAndColorToAllBundleSelects();

      // Apply initial two-bundle filtering based on currently selected shell variant
      if (twoBundleContainer) {
        const shellSelect = document.querySelector(
          'select[name="id"][data-product-select], select[data-product-select]',
        );
        const currentVariantId = shellSelect ? shellSelect.value : null;
        if (currentVariantId) {
          updateBundleSelectsFromShellVariant(twoBundleContainer, currentVariantId);
        }
      }

      getBundleContainers().forEach((container) => {
        getBundleSelects(container).forEach((selectEl) => updateCardFromSelect(selectEl));
      });
      updateTwoBundlePrice();
    };

    runSync();
    setTimeout(runSync, 80);
    setTimeout(runSync, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundleIt);
  } else {
    initBundleIt();
  }

  document.addEventListener('shopify:section:load', initBundleIt);
})();
